import React from "react";
import { useHandlerContext } from "./providers/Handler";
import { useAppContext } from "../../AppProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFieldError } from "../../utilities/utilities";
import { getStockReleasesByCarrier } from "../../Components/Selects/AsyncSelect/api";
import { faLoader } from "../../utilities/fontawesomeIcons";
import {
  StockReleaseShipment,
  validate,
} from "../../Models/StockReleaseShipment";
import { StockReleaseByCarrier } from "../../Models/StockReleaseByCarrier";
import SyncSelect from "../../Components/Selects/SyncSelect/SyncSelect";
import Datepicker from "../../Components/DatePickers/DatePicker/DatePicker";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import ButtonConfirm from "../../Components/Buttons/Confirm";
import ButtonUtility from "../../Components/Buttons/Utility";
import moment from "moment";
import { AddressBookHandlerProvider } from "../AddressBook/providers";
import { AddressBookHandler } from "../AddressBook/AddressBookHandler";

export const Handler = () => {
  const { dictionary } = useAppContext();
  const {
    data,
    error,
    loader,
    action,
    event,
    delivery,
    edit,
    onSubmit,
    callback,
  } = useHandlerContext();

  const handleChange = (
    name: string,
    value: string | number | object | null,
    key: string,
  ) => {
    edit(
      {
        ...data,
        [name]: value,
      } as StockReleaseShipment,
      key as keyof StockReleaseShipment,
      false,
    );
  };

  return (
    <React.Fragment>
      <div className="row align-items-center mb-2">
        <div className="col">
          {/* <h3 className="text-center">{dictionary.shipments.stock_release}</h3> */}
        </div>
      </div>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <div className="row">
            <div className="col">
              <label className="label-2">
                {dictionary.references.carrier_reference}
              </label>
              <label className="label-3">{event?.carrierReference}</label>
            </div>
            {action === "details" && (
              <>
                <div className="col">
                  <label className="label-2">
                    {dictionary.users.creation_user}
                  </label>
                  <label className="label-3">{data?.creationUser}</label>
                </div>
                <div className="col">
                  <label className="label-2">
                    {dictionary.dates.creation_date}
                  </label>
                  <label className="label-3">
                    {moment(data.creationDate).format("DD/MM/YYYY HH:mm:ss")}
                  </label>
                </div>
              </>
            )}
          </div>
          {action !== "details" && event?.note && (
            <div className="row mt-2">
              <div className="col">
                <label className="label-2">{dictionary.words.reason}</label>
                <label className="label-3">{event?.note}</label>
              </div>
            </div>
          )}
          <div className="row mt-2">
            <div className="col">
              <label className="label-2">{dictionary.words.mode} *</label>
              <SyncSelect
                name="stockRelease"
                optionValue="code"
                optionLabel="name"
                value={data.stockRelease || null}
                onChange={(
                  name: string,
                  value: StockReleaseByCarrier | StockReleaseByCarrier[] | null,
                ) => {
                  if (action !== "details") {
                    handleChange(name, value, "stockReleaseCode");
                  }
                }}
                loadOptions={() =>
                  getStockReleasesByCarrier(event?.carrierCode as string)
                }
                isClearable={false}
                error={getFieldError(error, "stockReleaseCode")}
                placeholder={dictionary.actions.select}
                isDisabled={action === "details"}
              />
            </div>
          </div>
          <div className="row mt-2">
            {data.stockRelease?.deliveryDateRequired && (
              <div className="col">
                <label className="label-2">
                  {dictionary.dates.delivery_date} *
                </label>
                <Datepicker
                  name="newDeliveryDate"
                  selectedDate={data.newDeliveryDate || null}
                  onChange={(name: string, value: Date | null) =>
                    handleChange(name, value, "newDeliveryDate")
                  }
                  isDisabled={action === "details"}
                />
              </div>
            )}
            {data.stockRelease?.noteRequired && (
              <div className="col">
                <label className="label-2">{dictionary.words.note} *</label>
                <InputBoxIcon
                  name={"note"}
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "note")
                  }
                  value={data.note}
                  disabled={action === "details"}
                />
              </div>
            )}
          </div>
          {data.stockRelease?.addressRequired && delivery && (
            <AddressBookHandlerProvider
              autosave={true}
              label={`${dictionary.words.new_sm} ${dictionary.registries.receiver}`}
              ownerId={event?.senderId}
              callback={(addressBook) => {
                if (addressBook) {
                  handleChange(
                    "newDeliveryId",
                    addressBook.id,
                    "newDeliveryId",
                  );
                }
              }}
              service="shipment"
              action={action}
              registry={{ saveEnabled: false, searchEnabled: false }}
              defaultValue={delivery}
            >
              <AddressBookHandler />
            </AddressBookHandlerProvider>
          )}
          <div className="d-flex mt-2">
            <ButtonUtility
              className="w-50 me-2"
              onClick={() => {
                if (callback) {
                  callback();
                }
              }}
            >
              {dictionary.actions.cancel}
            </ButtonUtility>
            {action !== "details" && (
              <ButtonConfirm
                className="w-50"
                onClick={() => {
                  if (!validate(data as StockReleaseShipment)) {
                    onSubmit(data.id);
                  }
                }}
                disabled={loader || !!validate(data as StockReleaseShipment)}
                loading={loader}
              ></ButtonConfirm>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
